var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('InputNumber',{ref:"input",attrs:{"value":_vm.value,"size":_vm.size,"max":_vm.max,"min":_vm.min},on:{"on-change":_vm.onchange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }